import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var EnvEng = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m39.445 26.861-.1-.1-12.524-5.914c-.2-1.202-.802-2.305-1.703-3.007L26.22 4.11v-.1C26.12 1.803 24.216 0 22.012 0s-4.108 1.704-4.208 4.01v.1l1.102 13.73c-.901.702-1.503 1.805-1.703 3.007L4.679 26.761s-.1 0-.1.1c-1.903 1.203-2.404 3.709-1.302 5.613 1.102 1.904 3.607 2.706 5.51 1.704 0 0 .1 0 .1-.1l11.322-7.919c.3.1.6.2 1.002.301v15.736H10.19c-.501 0-.902.4-.902.902 0 .501.4.902.902.902h23.945c.5 0 .901-.4.901-.902 0-.501-.4-.902-.901-.902H23.114V26.46c.2-.1.501-.1.701-.2l11.322 7.817s.1 0 .1.1c2.003 1.003 4.408.301 5.51-1.703 1.102-1.904.501-4.41-1.302-5.613Zm-31.46 5.713c-1.101.501-2.504.1-3.105-1.002-.601-1.103-.3-2.506.701-3.207l11.722-5.513c.2.902.701 1.604 1.303 2.305l-10.62 7.417Zm14.027-30.77c1.202 0 2.304.902 2.404 2.205l-1.102 12.93c-.4-.1-.901-.201-1.302-.201-.4 0-.902.1-1.303.2L19.608 4.01c.1-1.203 1.202-2.205 2.404-2.205Zm0 22.952a3.122 3.122 0 0 1-3.106-3.107 3.122 3.122 0 0 1 3.106-3.107 3.122 3.122 0 0 1 3.106 3.107 3.122 3.122 0 0 1-3.106 3.107Zm17.132 6.816c-.601 1.102-2.004 1.503-3.106 1.002l-10.72-7.417c.601-.601 1.102-1.403 1.303-2.205l11.722 5.513a2.185 2.185 0 0 1 .801 3.107Z"
  }));
});
EnvEng.displayName = 'EnvEng';
EnvEng.defaultProps = {
  'aria-label': 'EnvEng'
};
export default EnvEng;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/EnvEng.js
// module id = 3014
// module chunks = 11